import useWindowSize from "hooks/useWindowSize";
import { RatedDeck } from "utils/rating";
import { useEffect, useRef, useState } from "react";
import FormNav from "../FormNav";
import FormStyles from "../styled";
import { Positions, Teams } from "types/Player";
import Button from "components/Button";
import Deck from "components/Deck";
import { StepProps } from "../Form";
import styled, { css } from "styled-components";
import { NotificationManager } from "react-notifications";
import Checkbox from "components/Checkbox";

import { toPng } from "html-to-image";
import ITrainer from "types/Trainer";

import comlink from "worker/index";
import * as Comlink from "comlink";

const ProgressButton = styled(Button)`
  /* border-radius: 15px 15px 0 0; */
  margin-bottom: 16px;
`;
const ProgressBar = styled.div`
  width: 80%;
  margin: auto;
  border-radius: 15px;
  background: rgb(11 18 26);
  height: 5px;
  overflow: hidden;

  > div {
    height: 100%;
    width: 100%;
    border-radius: 15px;
    transform: translateX(-100%);
    background: white;
    transition: 50ms;
  }
`;

const Decks = (props: StepProps) => {
  const [decks, setDecks] = useState<RatedDeck[]>([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [fastMode, setFastMode] = useState(false);
  const { width } = useWindowSize();

  useEffect(() => {
    comlink.proxy.onmessage = (ev) => {
      const data = ev.data;

      try {
        const parsed = typeof data === "string" ? JSON.parse(data) : data;

        if (parsed.progress) {
          setProgress(parsed.progress);
        }
      } catch (e) {}
    };
  }, []);

  const team = props?.team !== "any" ? props.team : undefined;

  useEffect(() => {
    setDecks([]);
  }, [props.team, props.type, props.position, props.trainers]);

  const onCalculate = async () => {
    setLoading(true);
    const trainers = props.trainers || ([] as ITrainer[]);

    const player = {
      team: team as Teams,
      position: props.position as Positions,
      positionType: props.type as any,
    };

    const ratedDecks = !fastMode
      ? await comlink.wrapper.getRatedDecks(trainers, player, props.config, props.filters, props.locked)
      : await comlink.wrapper.getRatedDecksFast(trainers, player, props.config, props.filters, props.locked);

    setLoading(false);

    if (ratedDecks.length === 0) {
      NotificationManager.warning(`Couldn't find any deck`);
    }

    setDecks(ratedDecks);
  };

  const updateFastMode = (checked: boolean) => {
    setFastMode(checked);
  };

  const Options = (
    <FormStyles.Cards>
      {/* <FormStyles.Card>
        <FormStyles.CardTitle>Position</FormStyles.CardTitle>
        <FormStyles.CardContent>{props.position}</FormStyles.CardContent>
      </FormStyles.Card>

      <FormStyles.Card>
        <FormStyles.CardTitle>Team</FormStyles.CardTitle>
        <FormStyles.CardContent>
          {props.team}
          {team && <img src={ImagesUtils.getTeamImage(props.team as Teams)}></img>}
        </FormStyles.CardContent>
      </FormStyles.Card>

      <FormStyles.Card
        style={{
          flex: '1',
          overflow: 'auto',
        }}
      >
        <FormStyles.CardTitle>Trainers</FormStyles.CardTitle>
        <FormStyles.CardContent style={{ display: 'block' }}>
          <div>
            {props.trainers?.map((trainer) => (
              <InlineTrainer data={trainer} key={trainer.name} />
            ))}
          </div>
        </FormStyles.CardContent>
      </FormStyles.Card> */}

      <FormStyles.Submit>
        <div
          style={{
            marginBottom: "16px",
          }}
        >
          <Checkbox onChecked={updateFastMode} label={"Fast Mode (Not 100% accurate)"} checked={fastMode} />
        </div>

        <ProgressButton onClick={onCalculate} disabled={loading}>
          {loading ? `Generating Decks (${(progress * 100).toFixed(2)}%)` : "Generate Decks"}
        </ProgressButton>

        {progress > 0 && (
          <ProgressBar>
            <div style={{ transform: `translateX(${progress * 100 - 100}%)` }}></div>
          </ProgressBar>
        )}
      </FormStyles.Submit>
    </FormStyles.Cards>
  );

  const decksRef = useRef<HTMLDivElement>();

  const Decks = decks.map((rated, index) => (
    <Deck
      key={rated.deck.map((t) => t.name).join("-")}
      trainers={rated.deck}
      skills={rated.data.skills}
      rating={rated.data.rating}
      events={rated.data.events}
      rank={index + 1}
      position={rated.data.position || props.position}
      team={rated.data.team || team}
    />
  ));

  const showDecks = decks.length > 0 && !loading;

  const save = () => {
    toPng(decksRef.current, { quality: 0.95 }).then(function (dataUrl) {
      var link = document.createElement("a");
      link.download = "decks.png";
      link.href = dataUrl;
      link.click();
    });
  };

  const SavePDFButton = (
    <div>
      <Button onClick={save}>Save as PNG</Button>
    </div>
  );

  return (
    <FormStyles.Step>
      <FormStyles.StepContent>
        {!showDecks && Options}

        {showDecks && <FormStyles.Decks ref={decksRef}>{Decks}</FormStyles.Decks>}
      </FormStyles.StepContent>
      <FormNav {...props} buttons={showDecks ? [SavePDFButton] : undefined} />
    </FormStyles.Step>
  );
};

export default Decks;
